// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { z } from 'zod';

/** Schema for creating/editing an education entry. */
export const educationSchema = z.object({
  institution: z
    .string()
    .min(1, 'Institution is required.')
    .max(255, 'Institution must be at most 255 characters.'),
  degree: z
    .string()
    .max(255, 'Degree must be at most 255 characters.')
    .optional()
    .or(z.literal('')),
  field_of_study: z
    .string()
    .max(255, 'Field of study must be at most 255 characters.')
    .optional()
    .or(z.literal('')),
  start_date: z.string().optional().or(z.literal('')),
  end_date: z.string().optional().or(z.literal('')),
  gpa: z
    .string()
    .max(20, 'GPA must be at most 20 characters.')
    .optional()
    .or(z.literal('')),
  description: z
    .string()
    .max(10000, 'Description must be at most 10,000 characters.')
    .optional()
    .or(z.literal('')),
});

export type EducationFormData = z.infer<typeof educationSchema>;
